// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-breadcrumb {
  padding: 5px 20px;
  margin-bottom: 10px;
}

.custom-breadcrumb .breadcrumb-item {
  font-size: 16px;
  font-weight: 500;
}

.custom-breadcrumb .breadcrumb-item a {
  text-decoration: none;
  color: #007bff;
  transition: color 0.3s ease;
}

.custom-breadcrumb .breadcrumb-item a:hover {
  color: #0056b3;
}

.custom-breadcrumb .breadcrumb-item.active {
  font-weight: bold;
  color: #6c757d;
}
`, "",{"version":3,"sources":["webpack://./src/Components/BreadCrumb.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB","sourcesContent":[".custom-breadcrumb {\n  padding: 5px 20px;\n  margin-bottom: 10px;\n}\n\n.custom-breadcrumb .breadcrumb-item {\n  font-size: 16px;\n  font-weight: 500;\n}\n\n.custom-breadcrumb .breadcrumb-item a {\n  text-decoration: none;\n  color: #007bff;\n  transition: color 0.3s ease;\n}\n\n.custom-breadcrumb .breadcrumb-item a:hover {\n  color: #0056b3;\n}\n\n.custom-breadcrumb .breadcrumb-item.active {\n  font-weight: bold;\n  color: #6c757d;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
